import { Story } from "./story";

export class Task extends Story {

    parent_id: number;
    bug_id: number;
    task_category_id: number;

    constructor(obj: any = {}) {
        super(obj);
        this.parent_id = obj.parent_id;
        this.task_category_id = obj.task_category_id;
    } 
}



// WEBPACK FOOTER //
// ./src/app/modules/models/task.ts